<template lang="html">

  <div class="form-order">

    <div class="form_container form-flex">

      <div class="container-order">

        <div class="chooseOrder order-block">

          <div class="vitrina-content">

            <div class="formContent">
                <div class="formTitle">
                  <h1>Tus órdenes</h1>
                </div>
                <input
                  id="search-bar"
                  type="search"
                  class=" form-control col-md-4"
                  v-model="filterValue"
                  placeholder="Buscar..."


                >

                <div class="col-md-6">


                 <select
                  class="form-control"
                  v-model="equipaje"
                >
                  <option   value="" >Seleccionar equipaje</option>
                  <option
                    :value=" luggageItem.attributes.luggage_type.attributes.name + ' - ' + luggageItem.numeration"
                     v-for="luggageItem of dataLocal.dataLuggage.luggage_items"
                  >{{luggageItem.attributes.luggage_type.attributes.name.charAt(0).toUpperCase()+ luggageItem.attributes.luggage_type.attributes.name.slice(1)}} -  {{luggageItem.numeration}}</option>
                 </select>
                 </div>
            </div>


            <!-- <div class="filter-search" id="icon-search">
              <input id="search-bar" type="text" class="input form-control" placeholder="Buscar..." >
            </div> -->
            <div v-if ="availableOrders.length <=0">
              <span class="page-stats no-orders">No cuenta con órdenes disponibles para este embarque</span>

            </div>

            <div class="vitrinaContainer">

              <div class="vitrina">

                <ul>
                  <!-- :key="order.id" -->

                    <!-- v-if="order.visible" -->
                    <!-- order.attributes.available_items_to_package !== 0 -->
                   <li v-if="order.attributes.available_items_to_package > 0 "  v-for="(order) in items" :key="order.id">
                       <cardListOrders  v-bind:currentOrder="order" v-bind:stock="order.attributes.available_items_to_package" v-bind:dataLocal="dataLocal" v-bind:equipaje="equipaje"    v-bind:totalWeightKg="totalWeightKg" @add-package="addPackage" ></cardListOrders>


                  </li>
                </ul>
              </div>
            </div>

          </div>

        </div>

        <div class="resumeOrder order-block">

          <div class="vitrina-content">

          <div class="formContent">

            <div class="formTitle">
              <h1>Tu embarque</h1>
              <b-button  class="btn-primary" style="margin-left:30px"  @click="openAcordion" >{{isShowAll ?  'Cerrar todo' : 'Abrir todo'}}</b-button>
            </div>

            <div class="formNew" data-toggle="modal" data-target="#modalSuitcase" >

              <div class="weightContent">
                <span>{{totalWeightKg.toFixed(2)|currency}} Kg</span>
              </div>

              <!-- <b-button  class="btn-primary"  @click="savePackages" :disabled="availableOrders.length <=0 ">Guardar</b-button> -->
              <b-button  class="btn-primary"  @click="savePackages" >Guardar</b-button>


              <b-button  class="btn-primary" style="margin-left:15px"  @click="form4" >Continuar</b-button>
            </div>

          </div>

          <!-- <div class="filter-search" id="icon-search">
            <input id="search-bar" type="text" class="input form-control" placeholder="Buscar..." >
          </div> -->

          <div v-for="luggageItem of dataLocal.dataLuggage.luggage_items">
          <div ref="parentAcoordition" class="card panel-group" id="accordion">
             <div class="details-content-title collapsed " id="headingclient" data-toggle="collapse" :data-target="'#collapseclient'+luggageItem.numeration" aria-expanded="false" :aria-controls="'collapseclient'+luggageItem.numeration">
                  <span>{{luggageItem.attributes.luggage_type.attributes.name.charAt(0).toUpperCase()+ luggageItem.attributes.luggage_type.attributes.name.slice(1)}} -  {{luggageItem.numeration}}</span>
                  <div class="details-text up-arrow"></div>
            </div>

              <div :id="'collapseclient' +luggageItem.numeration" :class="isShowAll ? 'collapse show' : 'collapse' " aria-labelledby="headingclient">
                <div class="details-content-info">
                    <div class="card-body">
                      <div class="resumen-type">
                        <div class="vitrinaContainer">
                          <div class="vitrina">
                            <ul>
                                <li v-for="(addedPackage) of packagesToSave" v-if="luggageItem.attributes.luggage_type.attributes.name +' - '+luggageItem.numeration=== addedPackage.equipaje">
                                    <cardDeleteOrders v-bind:dataOrder="addedPackage"   @quit-package="quitPackage"  ></cardDeleteOrders>

                                </li>
                             </ul>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>



                      <div class="text-right" v-for="suma of sumaTotalPeso"  v-if=" luggageItem.attributes.luggage_type.attributes.name +' - '+luggageItem.numeration === suma.tipo " >
                        <div class="sumaPeso" >
                         <span  v-if="typeof(suma.sumaPeso) === 'undefined'"> {{luggageItem.attributes.weight}} Kg</span>
                          <span  v-else>{{suma.sumaPeso.toFixed(2)}} Kg</span>

                        </div>
                      </div>

                      <div class="text-right"  style ="margin-right:300px"  v-for="suma2 of sumaTotalPrecio" v-if=" luggageItem.attributes.luggage_type.attributes.name +' - '+luggageItem.numeration === suma2.tipo " >
                        <div class="sumaPrecio" >
                         <span  v-if="typeof(suma2.precio) === 'undefined'"> $ 0</span>
                          <span  v-else>$ {{suma2.precio.toFixed(2)}}</span>
                        </div>
                      </div>

              </div>
          </div>
         </div>


          <div class="formContent" style="margin-left:460px">
            <div class="formNew" data-toggle="modal" data-target="#modalSuitcase" >

              <div class="weightContent">
                <span>{{totalWeightKg.toFixed(2)|currency}} Kg</span>
              </div>
              <b-button  class="btn-primary"  @click="savePackages" >Guardar</b-button>
              <b-button  class="btn-primary" style="margin-left:15px"  @click="form4" >Continuar</b-button>
            </div>

          </div>


<!--

          <div class="vitrinaContainer">
            <div class="vitrina">
            <ul>

              <li v-for="(addedPackage) of packagesToSave">
                  <cardDeleteOrders v-bind:dataOrder="addedPackage"   @quit-package="quitPackage" ></cardDeleteOrders>
                  <p>{{addedPackage}}</p>
              </li>
            </ul>
          </div>
          </div> -->


                                   <!-- <p>{{pasarEmbarque }}</p>
                                   <br>
                                   <p>{{packagesToSave }}</p> -->


        </div>

      </div>

      </div>

      </div>

    </div>

  </div>


</template>

<script>
import cardListOrders from '@/components/prefab/items/card-list-orders.vue'
import cardDeleteOrders from '@/components/prefab/items/card-delete-orders.vue'
import { ordersService } from '@/services/orders.service'
import { shipmentService } from '@/services/shipment.service'
export default {
  props: ['id', 'dataLocal'],
  components: {
    cardListOrders,
    cardDeleteOrders
  },
  data() {
    return {
      resultado:'',
      equipaje: '',
      enumeration: '',
      creatorId: '',
      destinationId: '',
      dataOrderCopy: null,
      availableOrders: [],
      packagesToSave: [],
      isShowAll: false,
      filterValue:''
    }
  },
  created() {
    this.fetchData()
    this.findAvailableOrdersById()

  },
  methods: {
    form4() {
      this.$emit('go-toForm4')
    },
    openAcordion() {
      this.isShowAll = !this.isShowAll
    },

    inicialiceDataLocal() {
      this.dataOrderCopy = this.dataLocal.dataOrder
    },
    async savePackages() {
      console.log('Estamos en save packages')

      let formData = new Object()

      this.packagesToSave.forEach(pack => {
        delete pack.order_info
      })


      formData = this.pasarEmbarque
      let pasarArray = {"packages_to_save":Object.values(formData)}
       //formData.packages_to_save = this.packagesToSave
      console.log('paso 1')
      let response = await shipmentService.savePackages(this.id,pasarArray)
      console.log(response)

      console.log('paso 2')

      this.$emit('packages-saved')

    },
    callbackTest(value) {
      console.log('estamos en el callback de prueba')
      return
    },

    getAvailableOrders(retrievedOrders) {
      console.log(retrievedOrders)
      this.availableOrders = retrievedOrders
      this.availableOrders.forEach(order => {
        order.visible = true
      })

    },
    fetchData() {
      this.inicialiceDataLocal()
      this.destinationId = this.dataLocal.dataShipment.destination_id
      this.creatorId  = this.dataLocal.dataShipment.creator_operator_id

      let packagesFromServer = this.dataLocal.dataOrder.packages
      if(packagesFromServer){
        packagesFromServer.forEach(pack => {
          let packObj = new Object()
          packObj.id = pack.id
          packObj.number_of_items = pack.attributes.number_of_items
          packObj.partial_weight = pack.attributes.partial_weight
          packObj.purchase_order_id = pack.attributes.purchase_order_id
          packObj.numeration =pack.attributes.numeration
          packObj.luggageName =pack.attributes.luggageName
          packObj.realPrice =pack.attributes.purchaseOrder.attributes.real_price
          packObj.equipaje = pack.attributes.luggageName + ' - ' + pack.attributes.numeration
          packObj.partial_price = pack.attributes.partial_price
          // packObj.modified = 1
          let orderInfo = new Object()

          orderInfo.product_info =  pack.attributes.purchaseOrder.attributes.product_info
          orderInfo.product_image_url =  pack.attributes.purchaseOrder.attributes.product_image_url
          orderInfo.product_specimens =  pack.attributes.purchaseOrder.attributes.product_specimens
          orderInfo.order_code = pack.attributes.purchaseOrder.attributes.order_code
          orderInfo.weight_kg = pack.attributes.purchaseOrder.attributes.weight_kg
          orderInfo.id = null
          orderInfo.purchaseOrder = pack.attributes.purchaseOrder
          packObj.order_info = orderInfo

          this.packagesToSave.push(packObj)
        })
      }

      ordersService.listOrdersByCityAndOperator(
        this.creatorId,
        this.destinationId,
        this.getAvailableOrders
      )
    },
    addPackage(newPackage) {
      // { id: 5 }
      // packagesToSave = [{id:3}, { id: 5}, { id:5}]
      console.log( this.packagesToSave," this.packagesToSave")

      console.log('En add package')
      console.log(newPackage)

      newPackage.number_of_items = parseInt(newPackage.number_of_items)
      newPackage.partial_weight = parseFloat(newPackage.partial_weight)
      let retrievedOrder = this.findAvailableOrdersById(
        newPackage.order_info.id
      )
      //retrievedOrder.visible = false
      //retrievedOrder.visible = retrievedOrder.attributes.available_items_to_package === 0 ? false : true
      retrievedOrder.attributes.available_items_to_package = retrievedOrder.attributes.available_items_to_package - newPackage.number_of_items

      // if (
      //   typeof retrievedOrder.number_of_items_prev !== 'undefined' &&
      //   retrievedOrder.number_of_items_prev
      // ) {
      //   newPackage.modified =
      //     newPackage.number_of_items != retrievedOrder.number_of_items_prev
      //       ? 1
      //       : 0
      // }
      let existOrder = this.packagesToSave.find(item  => item.purchase_order_id === newPackage.purchase_order_id && item.equipaje === newPackage.equipaje)

      if(existOrder){
        existOrder.number_of_items = existOrder.number_of_items + newPackage.number_of_items
      }else{
         this.packagesToSave.push(newPackage)
      }
    },
    findAvailableOrdersById(keyId) {
      return this.availableOrders.find(function(order) {
        return order.id == keyId
      })
    },
    quitPackage(quitPackage) {

      const purchaseId = quitPackage.purchase_order_id

      // Obtiene un elemento del array principal por el id del purchase
      let order = this.findAvailableOrdersById(purchaseId)

      // Valida si el paquete fue guardado
      if (order) {

        order.attributes.available_items_to_package = quitPackage.number_of_items + order.attributes.available_items_to_package
      } else {
        let purchaseOrder = quitPackage.order_info.purchaseOrder
        purchaseOrder.attributes.available_items_to_package = quitPackage.number_of_items
        purchaseOrder.visible = true
        purchaseOrder.from_existing = true
        purchaseOrder.number_of_items_prev = quitPackage.number_of_items
        purchaseOrder.package_id = quitPackage.id
        this.availableOrders.push(purchaseOrder)
      }
      // Eliminar el item de la lista paquetes a guardar
      const removeIndex = this.packagesToSave.findIndex(item => item.purchase_order_id === purchaseId && item.equipaje === quitPackage.equipaje)
      this.packagesToSave.splice(removeIndex, 1)
    },


  },
  computed: {
    items() {
      return this.availableOrders.filter(item => {
        return item.attributes.order_code.toLowerCase().includes(this.filterValue.toLowerCase());
      });
    },
    totalWeightKg: function() {
      let total = 0

      this.packagesToSave.forEach(pack => {
        total = total + pack.partial_weight
      })

      if(this.dataLocal.dataLuggage.luggage_items){
        this.dataLocal.dataLuggage.luggage_items.forEach(luggage => {
          total = total + luggage.attributes.weight
        })
      }

      this.$emit('total-weight-updated', total)
      return total
    },
    sumaTotalPeso: function() {
      let paquetes = []

      this.dataLocal.dataLuggage.luggage_items.forEach(pack => {
          let suma = 0
          let equipaje = new Object()
          equipaje.tipo = pack.attributes.luggage_type.attributes.name + ' - '+ pack.numeration
          equipaje.attributo = [],
          this.packagesToSave.forEach(pack2 => {
              let articulo = new Object()
              articulo.tipo = pack2.equipaje
              articulo.peso = pack2.partial_weight

              if(articulo.tipo ===  equipaje.tipo ){
                   equipaje.attributo.push(articulo)
                   suma = suma +  articulo.peso
                   equipaje.sumaPeso =  suma + pack.attributes.weight
              }

          })

          paquetes.push(equipaje)
      })


      return paquetes
    },

    sumaTotalPrecio: function() {
      let paquetes2 = []

      this.dataLocal.dataLuggage.luggage_items.forEach(pack => {
          let suma = 0
          let equipaje = new Object()
          equipaje.tipo = pack.attributes.luggage_type.attributes.name + ' - '+ pack.numeration
          equipaje.attributo = [],
          this.packagesToSave.forEach(pack2 => {
              let articulo = new Object()
              articulo.tipo = pack2.equipaje
              articulo.precio = pack2.realPrice

              if(articulo.tipo ===  equipaje.tipo ){
                   equipaje.attributo.push(articulo)
                   suma = suma +  pack2.realPrice
                   equipaje.precio =  suma
              }

          })

          paquetes2.push(equipaje)
      })


      return paquetes2
    },

    //evaluar
    datosListar:function(){
      console.log("Ingreso a datos listar")
      let datosRecibidos = this.availableOrders
      let busqueda= datosRecibidos.reduce((prev, current) => {
        let index = current.id
        if (!prev[index]) {
          prev[index] = {  ...current, purchase_order_id: current.id }
        } else {

          let element = prev[index]
          prev[index] = { ...element, attributes: { ...element.attributes,available_items_to_package: element.attributes.available_items_to_package + current.attributes.available_items_to_package } }
        }
        return prev
      }, {})

      // let busqueda= datosRecibidos.reduce((prev, current) => {
      //   let index = current.id
      //   if (!prev[index]) {
      //     prev[index] = current
      //   } else {
      //     let element = prev[index]
      //     prev[index] = { ...element, attributes: { ...element.attributes,available_items_to_package: element.attributes.available_items_to_package + current.attributes.available_items_to_package } }
      //   }
      //   return prev
      // }, {})

      return  busqueda
    },

    pasarEmbarque:function(){

      let datosRecibidos = this.packagesToSave
      let busqueda= datosRecibidos.reduce((prev, current) => {
         let index = `${current.purchase_order_id}-${current.equipaje}`
          // let index = current.purchase_order_id
        if (!prev[index]) {
           prev[index] = current
        }
        else {
          let element = prev[index]
          prev[index] = { ...element, number_of_items: element.number_of_items + current.number_of_items,order_info: { ...element.order_info } }
        }
        return prev
      }, {})
      return  busqueda
    }
  }
}

</script>




// WEBPACK FOOTER //
// form-3-create-shipment.vue?3461662c